import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

export const StyledCaptionPanel = styled.div`
  /* Repo không reset border-box; thiếu dòng này panel ra 448px thay vì 400px. */
  &,
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  display: flex;
  /* Lấp đầy cột để kéo giãn được, nhưng chặn hai đầu theo thiết kế. */
  width: 100%;
  min-width: 400px;
  max-width: 512px;
  height: 100%;
  min-height: 0;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  background-color: ${COLOR.white};

  .caption-panel-header {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    width: 100%;
  }

  .caption-panel-title {
    flex: 1 0 0;
    min-width: 0;
    color: ${COLOR.black.default};
  }

  .caption-panel-icon-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 8px;
    border: none;
    border-radius: 8px;
    background: none;
    cursor: pointer;

    &:hover {
      background-color: ${COLOR.indigo[8]};
    }

    svg {
      width: 20px;
      height: 20px;
      color: ${COLOR.indigo[100]};
    }
  }

  .caption-panel-body-locked {
    opacity: 0.5;
  }

  .caption-panel-body-locked > * {
    pointer-events: none;
  }

  .caption-panel-body {
    flex: 1;
    /* align-items: center của panel làm con co lại nếu không đặt bề rộng. */
    width: 100%;
    min-height: 0;
    /* Vẫn cuộn được, chỉ ẩn thanh cuộn đi. */
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;
